// src/cmps/review/ReviewPreview.jsx
import { useState } from 'react'
import { utilService } from '../../services/util.service'
import { useDispatch } from 'react-redux'
import toast from 'react-hot-toast'
import { editReview, removeReview } from '../../store/slices/review.slice'
import { Link } from 'react-router-dom'
import { ReviewPopup } from './ReviewPopup'
import { Modal } from '../RegisterLogin/Modal'

export function ReviewPreview({ review, loggedInUser, users = [] }) {
  const dispatch = useDispatch()
  const [isEditing, setIsEditing] = useState(false)
  if (!review) return null

  const createdAt = review.createdAt ? new Date(review.createdAt) : new Date()
  const timeAgoStr = utilService.timeAgo(createdAt)

  const user = users.find((u) => u._id === review.userId) || {}
  const displayName = user.nickname || 'אורח'
  const userImage = user.image || 'https://placehold.co/150X180'

  const isOwner = loggedInUser && review.userId === loggedInUser._id

  async function handleEditSave(updatedData) {
    try {
      await dispatch(
        editReview({ reviewId: review._id, updatedData, loggedInUser })
      ).unwrap()
      toast.success('הביקורת נערכה בהצלחה!')
    } catch (err) {
      console.error('Error editing review:', err)
      toast.error('שגיאה בעריכת הביקורת.')
    }
    setIsEditing(false)
  }

  async function handleRemove() {
    try {
      await dispatch(
        removeReview({ reviewId: review._id, loggedInUser })
      ).unwrap()
      toast.success('הביקורת נמחקה בהצלחה!')
    } catch (err) {
      console.error('Error removing review:', err)
      toast.error('שגיאה במחיקת הביקורת.')
    }
  }

  if (isEditing) {
    return (
      <Modal onClose={() => setIsEditing(false)}>
        <ReviewPopup
          initialData={review}
          animeId={review.animeId}
          loggedInUser={loggedInUser}
          onClose={() => setIsEditing(false)}
        />
      </Modal>
    )
  }

  return (
    <div className="border-b border-gray-700 my-4 py-4 text-white flex gap-4">
      <div className="flex-shrink-0 w-20 h-20 rounded-full overflow-hidden">
        <Link to={`/user/${user.username}`}>
          <img
            src={userImage}
            alt={displayName}
            className="w-full h-full object-cover"
          />
        </Link>
      </div>
      <div className="flex flex-col flex-grow">
        <div className="flex justify-between items-center">
          <Link to={`/user/${user.username}`} className="text-lg font-bold">
            {displayName}
          </Link>
          <div className="text-sm text-gray-400">{timeAgoStr}</div>
        </div>
        {review.content && (
          <p className="mt-2 text-base max-w-[800px] leading-relaxed">
            {review.content}
          </p>
        )}
        <div className="mt-2 flex items-center gap-2 text-sm">
          {review.recommended !== null && (
            <span className="text-buttonSecondary1 font-semibold">
              {review.recommended ? 'ממליץ' : 'לא ממליץ'}
            </span>
          )}
          <span className="bg-[#464646] w-1 h-1 rounded-full"></span>
          <span className="text-buttonSecondary1 font-semibold">
            דירוג: {review.rating}/10
          </span>
        </div>
        {isOwner && (
          <div className="flex items-center text-sm gap-2 mt-3">
            <button
              onClick={() => setIsEditing(true)}
              className="text-muted hover:text-buttonSecondary1"
            >
              ערוך
            </button>
            <span className="bg-[#464646] w-1 h-1 rounded-full"></span>
            <button
              onClick={handleRemove}
              className="text-muted hover:text-red-500"
            >
              מחק
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
